export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./settings.vue?vue&type=template&id=47d7aad2&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/branches/branch/bk/settings.vue?vue&type=template&id=47d7aad2&scoped=true
// module id = EK2w
// module chunks = 0